import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1175px",
  marginBottom: "100px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  ".partners-subtitle": {
    textTransform: "uppercase",
    textAlign: "center",
    color: theme.palette.common.black,
    fontSize: "42px",
    marginBottom: "40px",
    [theme.breakpoints.down("lg")]: {
      fontSize: "36px",
      marginBottom: "30px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "26px",
      marginBottom: "20px",
    },
  },

  ".partners-grid-container": {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    columnGap: "32px",
    rowGap: "32px",
    [theme.breakpoints.down("md")]: { columnGap: "20px", rowGap: "20px" },
    [theme.breakpoints.down("sm")]: { columnGap: "16px", rowGap: "16px" },
  },

  ".partners-grid-item": {
    flex: "0 0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    aspectRatio: "5 / 3",
    "& img": {
      width: "auto",
      height: "auto",
      maxWidth: "85%",
      maxHeight: "85%",
      objectFit: "contain",
      display: "block",
    },
  },

  // ── Main: 1 entry, 2x normal cell width (about 66%) ──────────
  "&.tier-main .partners-grid-item": {
    flexBasis: "calc((200% - 32px) / 3)", // 2 of 3 columns + 1 gap
    [theme.breakpoints.down("md")]: { flexBasis: "calc((200% - 20px) / 3)" },
    [theme.breakpoints.down("sm")]: { flexBasis: "100%" }, // 1 per row, full width
  },
  "&.tier-main .partners-grid-item img": {
    maxWidth: "75%",
    maxHeight: "78%",
  },

  // ── Special: 3 per row max ───────────────────────────────────
  "&.tier-special .partners-grid-item": {
    flexBasis: "calc((100% - 2 * 32px) / 3)", // 3 per row at 32px gap
    [theme.breakpoints.down("md")]: { flexBasis: "calc((100% - 2 * 20px) / 3)" }, // 3
    [theme.breakpoints.down("sm")]: { flexBasis: "calc((100% - 16px) / 2)" }, // 2 — kept on mobile
  },
  "&.tier-special .partners-grid-item img": {
    maxWidth: "92%",
    maxHeight: "88%",
  },

  // ── Partner: 5 per row ───────────────────────────────────────
  "&.tier-partner .partners-grid-item": {
    flexBasis: "calc((100% - 4 * 32px) / 5)", // 5 per row
    [theme.breakpoints.down("lg")]: { flexBasis: "calc((100% - 3 * 32px) / 4)" }, // 4
    [theme.breakpoints.down("md")]: { flexBasis: "calc((100% - 2 * 20px) / 3)" }, // 3
    [theme.breakpoints.down("sm")]: { flexBasis: "calc((100% - 16px) / 2)" }, // 2
  },
  "&.tier-partner .partners-grid-item img": {
    maxWidth: "85%",
    maxHeight: "82%",
  },

  // ── Separated (when re-enabled): 2 per row ───────────────────
  "&.tier-separated .partners-grid-item": {
    flexBasis: "calc((100% - 32px) / 2)",
    [theme.breakpoints.down("sm")]: { flexBasis: "min(100%, 320px)" },
  },
  "&.tier-separated .partners-grid-item img": {
    maxWidth: "75%",
    maxHeight: "80%",
  },
}));

export default StyledWrapper;
